import styled from 'styled-components'
import { CardBody, CardHeader } from '~/views/components/elements/overview'
import { StaticCard } from '~/views/components/ProjectOverview/components/TaskSummaryCard/V2/Styled'
import { CARD_CONTAINER_MIN_HEIGHT } from '~/views/components/ProjectOverview/components/TimeTrackingSummary/helper'

export const ContainerCard = styled(StaticCard)(
  ({ theme }) => `
  flex: 1;
  min-height: ${CARD_CONTAINER_MIN_HEIGHT};
  margin: 0px ${
    theme.name === 'lightV2' ? theme.spacing(1) : theme.spacing(1.5)
  }px;
  padding-bottom: 0;
  background-color: #FFFEF5;
`,
)

export const CardHeaderContainer = styled(CardHeader)(
  ({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: ${
    theme.name === 'lightV2'
      ? theme.spacing(2, 2, 2.5, 2)
      : theme.spacing(3, 5, 4, 5)
  };
  border-bottom: 1px solid #FFE371;
`,
)

const LoadingTextPlaceholderStyle = styled.span`
  @apply text-gray;
`

export function LoadingTextPlaceholder() {
  return <LoadingTextPlaceholderStyle>-</LoadingTextPlaceholderStyle>
}

export const CardBodyContainer = styled(CardBody)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  padding: ${theme.name === 'lightV2' ? theme.spacing(2) : theme.spacing(5)};
  height: auto;
`,
)
//This additional wrapper centers the content vertically
export const CardBodyContent = styled.div(
  ({ theme }) => `
  display: flex;
  flex-flow: column;
  width: 100%;
  gap: ${theme.name === 'lightV2' ? theme.spacing(2) : theme.spacing(3)};
`,
)

export const LineDivider = styled.hr`
  height: 1px;
  background: #ffe371;
  width: 100%;
  border: none;
`
